export const getErrorMessage = async (response, defaultMessage) => {
  const errorData = await response.json().catch(() => ({}));
  return errorData.detail || errorData.message || defaultMessage;
};

export const handleApiRequest = async ({
  apiRequestConfig,
  showAlert,
  AlertType,
  networkErrorMessage,
}) => {
  try {
    const response = await apiRequestConfig();
    if (response.ok) {
      const data = await response.json();
      return { success: true, data };
    }
    const errorMessage = await getErrorMessage(response, 'Request failed.');
    showAlert(AlertType.Error, 'Error', errorMessage);
    return { success: false, error: errorMessage };
  } catch (error) {
    const errorMessage = error.message || networkErrorMessage;
    showAlert(AlertType.Error, 'Error', errorMessage);
    return { success: false, error: errorMessage };
  }
};
